"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  ENTER: 13,
  SPACE: 32,
  ESC: 27
};
//# sourceMappingURL=keys.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/lib/src/keys.js
// module id = 793
// module chunks = 57